import React, { useContext } from 'react';
import ReactDOM from 'react-dom';

//component
import AllUserGroupsScreen from  '@/components/page/OrgSettings/UserGroups/AllUserGroupsScreen';

//context
import { OrgSettingsContext } from '@/context/OrgSettings';



const AllUserGroupsPortal = () => {    
    const { setOrgId } = useContext(OrgSettingsContext);

    const targetContainer = document.getElementById('react-user-groups-container');
    if (!targetContainer) {
        return null;
    } else {
        setOrgId(targetContainer.getAttribute('data-org-id'))
    }

    return ReactDOM.createPortal(
      <AllUserGroupsScreen />, targetContainer
    );
}


export default AllUserGroupsPortal;